module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Cover#cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rtitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_TitlePage#title"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rscopy"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Copyright#copy"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Dedcation#ded"
    }
  }, [_vm._v("Dedcation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "repi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Front2#epi"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Part_1#part1"
    }
  }, [_vm._v("I"), _c('br'), _vm._v("The Shipment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_1#ch1"
    }
  }, [_vm._v("Eddie and Alberto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_2#ch2"
    }
  }, [_vm._v("The Crews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_3#ch3"
    }
  }, [_vm._v("Rodrigo and Mateo and Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_4#ch4"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jessie and Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Part_2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II"), _c('br'), _vm._v("The Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catalina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catalina and Jessie and Charlie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rpart3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Part_3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III"), _c('br'), _vm._v("The Crossings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rayo Luna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Chubasco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Chubasco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Chubasco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Chubasco")])]), _vm._v(" "), _c('p', {
    staticClass: "toc0",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780802156969_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudy")]), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3e91aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780802156969_Contents.vue
// module id = 78
// module chunks = 0